/**
 * Created by dx.yang on 2017/3/2.
 */

// export const setCookie = (name, value, days) => {
//     let domain, date, expires;

//     if (days) {
//         date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toGMTString();
//     } else {
//         expires = "";
//     }

//     domain = '.ksyun.com';

//     document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;

//     if (getCookie(name) == null || getCookie(name) != value) {
//         document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
//     }
// };

// export const getCookie = name => {
//     let nameEQ = name + "=";
//     let ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//         let c = ca[i];
//         while (c.charAt(0) == ' ') {
//             c = c.substring(1, c.length);
//         }
//         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//     }
//     return null;
// };


export default {
    setCookie: function (name, value, days) {
        let domain, date, expires;

        if (days) {
            date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }

        domain = '.ksyun.com';

        document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;

        if (getCookie(name) == null || getCookie(name) != value) {
            document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
        }
    },
    getCookie: function (name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}
